import React from 'react';
import { Link } from 'react-router-dom';
import './Breadcrumbs.scss';

interface BreadcrumbItem {
  path: string | null;
  label: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs = (props: BreadcrumbProps) => {
  const breadcrumbs = props.items.map((item) => (
    <div className="breadcrumb-item" key={item.label}>
      { item.path
        ? (
          <Link
            to={item.path}
          >
            {item.label}
          </Link>
        )
        : <span>{item.label}</span>}
    </div>
  ));
  return (
    <div className="breadcrumb">
      { breadcrumbs }
    </div>
  );
};

export default Breadcrumbs;
